import * as Locales from './locales'

const genKey = key => `__ui_settings_${key}__`

const getItem = (key, defaultValue = null) => {
  const k = genKey(key)
  const storageValue = localStorage.getItem(k)
  if (storageValue != null) {
    return storageValue
  }
  const globalValue = window[k]
  if (globalValue != null) {
    return String(globalValue)
  }
  return defaultValue
}

const getTokenFromIframeUrl = () => {
  const urlString = window.location.href
  const url = new URL(urlString)
  const ignitionToken = url.searchParams?.get('token')
  return ignitionToken
}

const getToken = (key, defaultValue = null) => {
  const keyLocalStorage = 'mavAuth'
  const localStorageValue =
    getTokenFromIframeUrl() || localStorage.getItem(keyLocalStorage)

  // token in local storage
  if (localStorageValue) {
    return localStorageValue
  }

  // token in session storage
  const sessionStorageValue = JSON.parse(sessionStorage.getItem(key))
  if (sessionStorageValue) {
    localStorage.setItem(keyLocalStorage, sessionStorageValue.cognito_auth)
    return sessionStorageValue.cognito_auth
  }

  return defaultValue
}

export const getTokenStorage = () => getToken('authCognito')

export const getGoogleMapKey = () =>
  getItem('google_maps_api_key', process.env.API_GOOGLE)

export const getLocale = () => getItem('locale') || Locales.types.FR

export const setLocale = language => {
  if (language != null) {
    localStorage.setItem(genKey('locale'), language)
  }
}

export const getLangFromUrl = () => {
  const urlString = window.location.href
  const url = new URL(urlString)
  const userLang = url.searchParams?.get('lang')
  return userLang
}
